export const externalVesselUrl = (mmsi: number) => {
    return `https://www.marinetraffic.com/en/ais/details/ships/mmsi:${mmsi}`;
};
